import cx from "classnames";
import React from "react";

import { ProductEntity, ProductQuality } from "@/mk2/apps/bazaar/schemas";
import { QUALITY_VALUES } from "@/mk/bazaar/common/enums";

import styles from "./ProductQualityBadge.mscss";

export type State = keyof ProductEntity["state"];

interface OwnProps {
    className?: string;
    quality: ProductQuality;
}

const ProductQualityBadge: React.FunctionComponent<OwnProps> = ({ className, quality }) => (
    <div className={cx(styles.ProductQualityBadge, className)}>
        <span
            className={cx(
                styles.ProductQualityBadge__badge,
                styles[`ProductQualityBadge__badge--${quality}`],
            )}
        >
            {QUALITY_VALUES[quality].label}
        </span>
    </div>
);

ProductQualityBadge.displayName = "ProductQualityBadge";

export default ProductQualityBadge;
